module.exports = __webpack_public_path__ + "static/media/clemente_castor_2.2dc654da.jpg";